
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Onetwojyotilinga() {



    const cardData =
    {
        keyword: '12 Jyotirlinga Darshan Bus Hire in Pune',
        heading: 'Amruta Travels: 12 Jyotirlinga Darshan Bus Hire in Pune',
        headingDescription: 'Amruta Travels offers 12 Jyotirlinga Darshan Bus Hire in Pune, making your spiritual journey comfortable, organized, and divine. Whether you are planning a family pilgrimage, group yatra, or religious tour, our well-maintained AC and non-AC buses ensure a peaceful and safe travel experience across all 12 sacred Jyotirlinga destinations in India. With experienced drivers, knowledgeable route planning, clean interiors, and round-the-clock support, Amruta Travels takes care of every detail of your holy journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "Jyotirlinga Darshan Bus Tour Pune",
      "description": "Embark on a spiritual journey with our Jyotirlinga Darshan Bus Tour from Pune. We offer customized bus tours covering all 12 Jyotirlingas in India, ensuring comfort, safety, and convenience. Our buses are equipped with air conditioning, comfortable seating, and modern amenities to make your pilgrimage experience serene and hassle-free."
    },
    {
      "name": "12 Jyotirlinga Bus Booking",
      "description": "Book a 12 Jyotirlinga Darshan tour bus for a complete pilgrimage journey. We provide buses for group tours to all 12 Jyotirlingas across India, offering comfort, reliable travel, and experienced drivers to make your sacred trip memorable."
    },
    {
      "name": "Pune to 12 Jyotirlinga AC Bus Hire",
      "description": "Hire an AC bus from Pune for your 12 Jyotirlinga Darshan journey. Our fleet includes luxury buses with air conditioning, spacious seating, and onboard amenities, ensuring a comfortable and enjoyable pilgrimage."
    },
    {
      "name": "Bharat Benz/Volvo for Jyotirlinga Darshan",
      "description": "Travel in luxury with Bharat Benz or Volvo buses for your Jyotirlinga Darshan. These buses are designed to offer a premium experience with comfortable seating, modern facilities, and reliable travel for your long-distance pilgrimage."
    },
    {
      "name": "Pilgrimage Tour Bus Pune",
      "description": "Join our pilgrimage tours from Pune with dedicated buses for temple visits and spiritual journeys. Whether you’re visiting the Jyotirlingas or other holy sites, our buses provide a safe and peaceful travel experience for groups."
    },
    {
      "name": "Religious Yatra Bus Pune",
      "description": "Explore various religious destinations with our Religious Yatra Bus services from Pune. Our buses are specially equipped for pilgrimage tours, ensuring your spiritual trip is both comfortable and peaceful."
    },
    {
      "name": "Group Bus for Jyotirlinga Tour",
      "description": "Take your group on a sacred pilgrimage to the Jyotirlingas with our group bus hire services. Our buses are designed for long-distance travel, with ample space, AC comfort, and modern amenities to make your religious journey special."
    },
    {
      "name": "45 Seater Bus Jyotirlinga Darshan",
      "description": "For large groups, our 45 Seater buses provide the perfect travel solution for the Jyotirlinga Darshan. With AC, comfortable seating, and an experienced driver, your pilgrimage trip will be both convenient and pleasant."
    },
    {
      "name": "Jyotirlinga Tour by Volvo Pune",
      "description": "Travel in style with a Volvo bus for your Jyotirlinga Darshan from Pune. Our Volvo buses offer superior comfort, luxury, and a smooth ride, making your spiritual journey a peaceful and memorable experience."
    },
    {
      "name": "Jyotirlinga Tour Bus Services Pune",
      "description": "Our specialized Jyotirlinga Tour Bus services from Pune ensure that you have a dedicated vehicle for your pilgrimage. From booking to transportation, we take care of everything, so you can focus on your spiritual journey."
    },
    {
      "name": "Long Distance Temple Bus Hire",
      "description": "Our Long Distance Temple Bus Hire services are perfect for those looking to visit multiple religious destinations in one trip. With ample space, AC comfort, and a professional driver, we ensure a comfortable journey for your temple tours."
    },
    {
      "name": "Pune to Maharashtra Jyotirlinga Yatra",
      "description": "Take a divine journey from Pune to Maharashtra’s Jyotirlingas with our specialized bus services. Our buses are equipped with all the amenities you need for a smooth, comfortable pilgrimage to places like Grishneshwar, Trimbakeshwar, and more."
    },
    {
      "name": "AC Coach Jyotirlinga Trip Pune",
      "description": "Experience the Jyotirlinga Darshan with our AC Coach services. These coaches provide a comfortable, air-conditioned environment for long-distance pilgrimage trips, ensuring that your spiritual journey is as peaceful as it is meaningful."
    },
    {
      "name": "Bharat Benz AC Jyotirlinga Travel",
      "description": "Travel in luxury with Bharat Benz AC buses for your Jyotirlinga Darshan. These buses are ideal for long-distance travel, offering top-of-the-line amenities and ensuring a smooth, comfortable ride to all the sacred destinations."
    },
    {
      "name": "Pune Jyotirlinga Package Bus Hire",
      "description": "Book a comprehensive Jyotirlinga Package Bus from Pune, which covers all the major temples in India. Our well-maintained buses come with air conditioning, comfortable seats, and professional drivers to ensure a stress-free pilgrimage experience."
    }
  ],
  "tableData": [
    ["Jyotirlinga Darshan Bus Tour Pune", "12 Jyotirlinga Bus Booking"],
    ["Pune to 12 Jyotirlinga AC Bus Hire", "Bharat Benz/Volvo for Jyotirlinga Darshan"],
    ["Pilgrimage Tour Bus Pune", "Religious Yatra Bus Pune"],
    ["Group Bus for Jyotirlinga Tour", "45 Seater Bus Jyotirlinga Darshan"],
    ["Jyotirlinga Tour by Volvo Pune", "Jyotirlinga Tour Bus Services Pune"],
    ["Long Distance Temple Bus Hire", "Pune to Maharashtra Jyotirlinga Yatra"],
    ["AC Coach Jyotirlinga Trip Pune", "Bharat Benz AC Jyotirlinga Travel"],
    ["Pune Jyotirlinga Package Bus Hire"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "12 Jyotirlinga Darshan Bus Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers exclusive bus rentals for the 12 Jyotirlinga Darshan tour from Pune. Whether you’re planning a religious pilgrimage or a group visit to the sacred Jyotirlingas across India, our buses provide a comfortable, reliable, and safe way to travel to these spiritual destinations."
  },
  {
    "WhyChooseheading": "Comfortable and Air-Conditioned Travel for Religious Tours",
    "WhyChoosedescription": "Our buses are equipped with air-conditioning and spacious seating, ensuring you and your group travel in comfort during this long pilgrimage journey. The 12 Jyotirlinga tour requires a comfortable ride, and our buses are designed to make your religious journey peaceful and pleasant."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for a Safe Journey",
    "WhyChoosedescription": "Our drivers are experienced, licensed, and familiar with the routes to the 12 Jyotirlinga temples. They prioritize safety and punctuality, ensuring that your pilgrimage is smooth, timely, and hassle-free, while providing a respectful and professional experience."
  },
  {
    "WhyChooseheading": "Ideal for Group Pilgrimage and Religious Tours",
    "WhyChoosedescription": "The 12 Jyotirlinga Darshan tour is perfect for religious groups, families, and friends. Our buses can accommodate large groups comfortably, so everyone can travel together in one vehicle, making the experience more meaningful and united."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Religious Tours",
    "WhyChoosedescription": "We offer affordable and transparent pricing for 12 Jyotirlinga Darshan bus rentals. Our all-inclusive rates cover fuel, tolls, driver allowances, taxes, and more, allowing you to plan your pilgrimage without worrying about hidden charges."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for Long-Distance Travel",
    "WhyChoosedescription": "Our buses undergo regular maintenance and safety checks to ensure a smooth, reliable, and safe ride for your long-distance journey. You can trust our well-maintained buses to get you to each of the 12 Jyotirlinga temples without any issues."
  },
  {
    "WhyChooseheading": "Spiritual and Comfortable Environment for Your Pilgrimage",
    "WhyChoosedescription": "We understand the importance of a peaceful pilgrimage experience. Our buses are equipped with comfortable seats, clean interiors, and sufficient space for everyone to relax and prepare for the spiritual journey ahead. Let us provide a serene and stress-free environment for your pilgrimage."
  },
  {
    "WhyChooseheading": "Convenient Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a bus for the 12 Jyotirlinga Darshan tour with Amruta Travels is easy. You can book online, over the phone, or at our office. Our 24/7 customer support team is available to assist with bookings, itinerary changes, and any special requests to make your pilgrimage even more special."
  }
]





















    }

const faqData = [
  {
    question: 'Can I hire a bus for 12 Jyotirlinga Darshan from Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers buses for hire for the 12 Jyotirlinga Darshan from Pune. Our buses are comfortable and well-equipped to ensure a smooth and enjoyable pilgrimage tour to the sacred Jyotirlingas across India.',
  },
  {
    question: 'What amenities are available in the bus for 12 Jyotirlinga Darshan?',
    answer: 'Our buses for the 12 Jyotirlinga Darshan are equipped with comfortable seating, air conditioning, entertainment options, ample legroom, overhead storage, and clean interiors. We also provide hygienic and safe travel for the long journey.',
  },
  {
    question: 'Is the 12 Jyotirlinga Darshan bus available for both local and outstation travel?',
    answer: 'Yes, the bus is available for both local travel in Pune as well as outstation travel to the 12 Jyotirlinga locations across India, ensuring a safe and comfortable journey for your entire group.',
  },
  {
    question: 'Is a driver included in the 12 Jyotirlinga Darshan bus rental?',
    answer: 'Yes, all our buses for the 12 Jyotirlinga Darshan come with a professional and experienced driver, who ensures a safe and smooth journey. The driver is familiar with the route and the destinations, ensuring a hassle-free pilgrimage experience.',
  },
  {
    question: 'How much does it cost to hire a bus for the 12 Jyotirlinga Darshan from Pune?',
    answer: 'The cost of hiring a bus for the 12 Jyotirlinga Darshan depends on the type of bus, distance, duration, and services required. Typically, the rates start from ₹30-₹40 per km. For an accurate quote, contact us with your detailed itinerary.',
  },
  {
    question: 'Is the bus comfortable for long journeys during the 12 Jyotirlinga Darshan?',
    answer: 'Yes, the buses we provide for the 12 Jyotirlinga Darshan are designed for long journeys, offering comfortable seating, air conditioning, and ample space for both passengers and luggage, making it an ideal choice for this extensive pilgrimage trip.',
  },
  {
    question: 'Are the buses for 12 Jyotirlinga Darshan well-maintained and sanitized?',
    answer: 'Absolutely. All our buses, including those for the 12 Jyotirlinga Darshan, are regularly maintained, thoroughly cleaned, and sanitized before every trip to ensure hygiene, safety, and comfort for the passengers.',
  },
  {
    question: 'How do I book a bus for 12 Jyotirlinga Darshan in Pune?',
    answer: 'You can easily book a bus for the 12 Jyotirlinga Darshan online through our website or by contacting our customer support team. We offer fast booking assistance and provide customized packages for your journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vijay Deshmukh',
    role: 'Pilgrimage Tour Coordinator, Pune',
    text: 'We hired a bus from Amruta Travels for the 12 Jyotirlinga Darshan. The service was excellent, the bus was comfortable, and the journey was smooth. The driver was experienced and ensured our group had a safe trip. Highly recommend Amruta Travels for pilgrimage tours!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Leela Sharma',
    role: 'Religious Tour Organizer',
    text: 'I booked a bus for the 12 Jyotirlinga Darshan with Amruta Travels. The bus was spacious, air-conditioned, and very comfortable for the long journey. The service was impeccable, and my group had a memorable experience. Thank you, Amruta Travels!',
    rating: 5,
  },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "12 Jyotirlinga Darshan Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/jyotirlinga-darshan-bus-pune.jpg",
  "description": "Amruta Travels offers 12 Jyotirlinga Darshan Bus Hire in Pune for a religious pilgrimage tour. Travel in comfort with our AC buses (Bharat Benz/Volvo) to visit all 12 Jyotirlingas across Maharashtra. Book your Jyotirlinga Yatra with experienced drivers and a safe, luxurious travel experience for group tours and temple visits.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/12-jyotirlinga-darshan-bus-hire-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 12 Jyotirlinga Darshan Bus Hire in Pune | Religious Yatra & Pilgrimage Tour</title>
  <meta 
    name="description" 
    content="Book a 12 Jyotirlinga Darshan Bus Hire in Pune for a pilgrimage tour to Maharashtra’s 12 Jyotirlingas. Travel in comfort with Bharat Benz/Volvo AC buses for a safe and luxurious Yatra experience." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onetwojyotilinga;